import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import loading from '../../images/loading.gif';
import './alert.css';

class ImageUploadConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: '',
    };
  }

  componentDidMount() {
    // for the first image upload
    this.previewFile();
  }

  componentDidUpdate(prevProps) {
    // for all subsequent image uploads
    if (prevProps.file.name !== this.props.file.name) {
      this.previewFile();
    }
  }

  previewFile = () => {
    const reader = new FileReader();
    const self = this;

    reader.addEventListener(
      'load',
      () => {
        self.setState({ src: reader.result });
      },
      false
    );

    if (this.props.file) {
      reader.readAsDataURL(this.props.file);
    }

    this.setState({ src: '' });
  };

  sendImageToDB = caller => {
    const formData = new FormData();
    formData.append(caller, this.props.file);

    const config = {
      method: 'PUT',
      headers: {
        'X-User-Email': JSON.parse(localStorage.state).auth.email,
        'X-User-Token': JSON.parse(localStorage.state).auth.token,
      },
      body: formData,
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/users`, config)
      .then(data => data.json())
      .then(response => {
        if (caller === 'uber_profile_image') {
          this.props.retrieveProfile();
        }
        console.log(response);
      })
      .catch(() => {
        console.log('error submitting image!');
      });
  };

  render() {
    const { closeDialog, isDialogOpen, tryFormEditSelect, file, caller } = this.props;

    return (
      <Dialog
        actions={
          <div className="buttons-div">
            <button
              type="button"
              className="alert-button"
              onClick={() => {
                if (caller === 'uber_profile_image') {
                  document.getElementById('profile-picture').src = loading;
                }
                this.sendImageToDB(caller);
                tryFormEditSelect(caller, file.name);
                closeDialog();
              }}>
              SUBMIT
            </button>
            <button type="button" className="alert-button" onClick={closeDialog}>
              CANCEL
            </button>
          </div>
        }
        open={isDialogOpen}
        paperProps={{ style: { borderRadius: '4px' } }}>
        <p style={{ textAlign: 'center' }}>OK to sumbit this image?</p>

        <div className="text-center">
          <img src={this.state.src} height="200" alt="Upload" id="imgTag" />
        </div>
      </Dialog>
    );
  }
}

export default ImageUploadConfirm;



// WEBPACK FOOTER //
// ./src/components/Alert/ImageUploadConfirm.js